/**
 * TT-243. Whole years since a date, counted by anniversary.
 *
 * Years of experience are never stored. They are derived from the date an
 * installer says they started, and the admin screen sets that date by
 * subtracting whole calendar years. Dividing the elapsed milliseconds by a
 * 365.25 day year disagreed with that: twenty-two calendar years spanning only
 * five leap days is 8,035 days, which divides to 21.998 and floors to 21.
 *
 * The backend was fixed in 0.26.68-1. This is the same rule, so the profile and
 * the Dashboard cannot disagree about the same installer.
 */
export function completedYearsSince(date?: Date | string | null): number | null {
  if (!date) {
    return null;
  }

  const from = new Date(date);
  if (Number.isNaN(from.getTime())) {
    return null;
  }

  const now = new Date();
  let years = now.getUTCFullYear() - from.getUTCFullYear();

  const anniversary = new Date(
    Date.UTC(
      now.getUTCFullYear(),
      from.getUTCMonth(),
      from.getUTCDate(),
      from.getUTCHours(),
      from.getUTCMinutes(),
      from.getUTCSeconds(),
      from.getUTCMilliseconds(),
    ),
  );
  if (now.getTime() < anniversary.getTime()) {
    years -= 1;
  }

  return Math.max(0, years);
}
